import { useContext, useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import ImageLoad from '../ImageLoad';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import PageLoader from '../PageLoader';
import { socket } from '../../socket';
import { useTranslation } from 'react-i18next';

const Chat = () => {
    const { t } = useTranslation();
    const { BaseUrl, handleCallApi, setShowToast, setToastMsg, } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [allChat, setAllChat] = useState([]);
    const [input, setInput] = useState("");
    const [showSosModal, setShowSosModal] = useState(false);
    const [sosTriggered, setSosTriggered] = useState(false);

    const handleTriggerSOS = () => {
        setShowSosModal(true);
    };

    const confirmSosTrigger = () => {
        const uid = secureLocalStorage.getItem("Userid");
        
        const triggerApi = (lat, lon) => {
            const body = {
                reporter_type: "customer",
                reporter_id: uid,
                latitude: lat.toString(),
                longitude: lon.toString()
            };
            handleCallApi("Post", "safety/sos_trigger", body).then((res) => {
                if (res.data.Result === true) {
                    setSosTriggered(true);
                    setShowToast(true);
                    setToastMsg("🚨 SOS Emergency Signal sent to support center successfully!");
                } else {
                    setShowToast(true);
                    setToastMsg(res.data.message || "Failed to trigger SOS");
                }
            }).catch((err) => {
                setShowToast(true);
                setToastMsg("Network connection error");
            });
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    triggerApi(position.coords.latitude, position.coords.longitude);
                },
                () => {
                    triggerApi(0.0, 0.0);
                }
            );
        } else {
            triggerApi(0.0, 0.0);
        }
        setShowSosModal(false);
    };

    const Location = useLocation();
    const navigate = useNavigate();
    const ChatRef = useRef(false);
    const chatBoxBodyRef = useRef(null);

    useEffect(() => {
        if (chatBoxBodyRef.current) {
            chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
        }
    }, [allChat]);

    useEffect(() => {
        if (ChatRef.current) return;
        ChatRef.current = true;
        handleFetchChatList();
    }, []);

    useEffect(() => {
        const uid = secureLocalStorage.getItem("Userid");
        
        const handleReconnect = () => {
            console.log("Socket reconnected in Chat, refreshing chat messages...");
            handleFetchChatList();
        };

        socket.on("connect", handleReconnect);
        socket.on(`New_Chat${uid}`, handleNewChat);
        
        return () => {
            socket.off("connect", handleReconnect);
            socket.off(`New_Chat${uid}`, handleNewChat);
        }
    }, []);

    const handleNewChat = (data) => {
        if (data) {

            const uid = secureLocalStorage.getItem("Userid");
            const status = data?.sender_id == uid ? 1 : 2;
            setAllChat((prev) => {
                const newPrev = [...prev];

                const chat = {
                    id: data?.id,
                    date: data?.date,
                    message: data?.message,
                    status
                }

                if (data?.new_date === "0") {
                    if (newPrev.length > 0) {
                        const lastIndex = newPrev.length - 1;
                        const GroupChat = {
                            ...newPrev[lastIndex],
                            chat: [...newPrev[lastIndex].chat, chat]
                        };
                        newPrev[lastIndex] = GroupChat;
                        return newPrev;
                    } else {
                        return [{ date: data?.new_date, chat: [chat] }];
                    }
                } else {
                    return [...newPrev, { date: data?.new_date, chat: [chat] }];
                }

            });
        }
    }

    const handleFetchChatList = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        const ApiBody = {
            uid,
            sender_id: uid,
            recevier_id: Location?.state?.id,
            status: "customer"
        }

        const Response = await handleCallApi("Post", "chat/chat_list", ApiBody);
        setAllChat(Response.data.chat_list);
        setLoading(false);
    }

    const handleSendMessage = () => {

        if (!input) {
            setShowToast(true);
            setToastMsg("Please write a message !!");
            return;
        }

        const uid = secureLocalStorage.getItem("Userid");
        const SocketBody = {
            sender_id: uid,
            recevier_id: Location?.state?.id,
            message: input,
            status: "customer",
        }

        socket.emit("Send_Chat", SocketBody);

        setInput("");
    }

    return (
        <div className="py-4">
            <div className="max-w-4xl h-[calc(100vh-100px)] mx-auto px-4 sm:px-6 lg:px-8">
                <div className="h-full flex flex-col gap-3">

                    <div className="bg-white shadow-[0_0_5px_0] shadow-black/20 px-4 py-[15px] rounded-[10px] flex items-center gap-4">
                        <button onClick={() => navigate(-1)}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="black" />
                            </svg>
                        </button>
                        <ImageLoad src={Location?.state?.img ? BaseUrl + Location.state.img : ""} CustomeStyle={"w-[40px] h-[40px] rounded-full overflow-hidden"} ImagStyle={"w-full h-full object-cover"} alt={Location?.state?.name} status={true} />
                        <h1 className="font-semibold">{Location?.state?.name}</h1>
                        <button onClick={handleTriggerSOS} className="ml-auto bg-red-600 hover:bg-red-700 text-white font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 text-xs transition-all duration-300 shadow-md hover:shadow-red-600/30">
                            <span className="animate-pulse">🔴</span> {t("SOS HELP")}
                        </button>
                    </div>

                    <div ref={chatBoxBodyRef} className="h-full bg-white shadow-[0_0_5px_0] shadow-black/20 px-4 py-[15px] rounded-[10px] overflow-y-auto scroll-container">
                        {allChat.length >= 1
                            ? allChat.map((item, index) => {
                                return <div key={index} className='space-y-4'>
                                    <p className='text-center font-medium text-gray-900 text-[14px] my-2'>{item.date}</p>
                                    {item?.chat.map((list, listindex) => {
                                        return <div key={listindex} className={`flex ${list.status === 1 ? "justify-end" : "justify-start"}`}>
                                            <div className={`${list.status === 1 ? "text-end" : "text-start"}`}>
                                                {list.status === 1 && <span className={`bg-[--bg-color] text-white py-[8px] px-[10px] rounded-[1.56rem_1.56rem_0.06rem_1.56rem]`}>{list.message}</span>}
                                                {list.status === 2 && <span className={`bg-gray-200 py-[8px] px-[10px] rounded-[1.56rem_1.56rem_1.56rem_0.06rem]`}>{list.message}</span>}
                                                <br />
                                                <span className='text-[11px] text-gray-400 mt-1 block'>{list.date}</span>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            })
                            : <div className="h-full flex flex-col items-center justify-center text-center p-6">
                                <div className="w-16 h-16 bg-blue-50 text-[--bg-color] rounded-full flex items-center justify-center mb-4">
                                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                                    </svg>
                                </div>
                                <h2 className="font-semibold text-gray-900 text-lg mb-1">{t("Start the Conversation")}</h2>
                                <p className="text-sm text-gray-500 max-w-sm">{t("Send a message to start chatting with your driver.")}</p>
                            </div>
                        }
                    </div>

                    <div className="bg-white px-4 py-[15px] rounded-[10px] shadow-[0_0_5px_0] shadow-black/20 flex items-center gap-2">
                        <input type="text" value={input} onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSendMessage();
                                }
                            }}
                            className='w-full border-2 rounded-[10px] px-[15px] py-[8px] outline-[--bg-color]' placeholder='Write a message' />
                        <button onClick={handleSendMessage} className='bg-[--bg-color] text-white p-[10px] rounded-[10px]'>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.447 3.06298L5.33394 6.34099C2.20094 7.12399 2.23193 11.588 5.37593 12.328L9.45503 13.288C9.55603 13.312 9.66303 13.282 9.73603 13.208L14.4741 8.46999C14.7641 8.17999 15.2439 8.17999 15.5339 8.46999C15.8239 8.75999 15.8239 9.23999 15.5339 9.52999L10.7939 14.27C10.7209 14.343 10.6901 14.45 10.7141 14.551L11.673 18.626C12.413 21.77 16.8769 21.801 17.6599 18.668L20.9379 5.55498C21.3129 4.04898 19.95 2.68698 18.447 3.06298Z" fill="white"></path></svg>
                        </button>
                    </div>

                </div>
            </div>

            {showSosModal && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl animate-fade-in">
                        <div className="text-center">
                            <div className="w-14 h-14 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                                </svg>
                            </div>
                            <h3 className="text-lg font-bold text-gray-900 mb-2">{t("Confirm SOS Emergency?")}</h3>
                            <p className="text-sm text-gray-500 mb-6">
                                {t("This will notify our 24/7 security dispatch team with your current coordinates for immediate assistance. Trigger only in real emergencies.")}
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <button onClick={() => setShowSosModal(false)} className="flex-1 border border-gray-300 text-gray-700 font-medium py-2 rounded-xl hover:bg-gray-50 transition-colors">
                                {t("Cancel")}
                            </button>
                            <button onClick={confirmSosTrigger} className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded-xl shadow-md transition-colors">
                                {t("Send SOS")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <PageLoader loading={loading} />

        </div>
    )
}

export default Chat